import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function RefundIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 30.9 34.32">
      <path d="M23.83 30a15.59 15.59 0 006.9-10.68A15.31 15.31 0 0027.11 7 16.29 16.29 0 0015.2 1.42h-.81V0L10.9 2.21l3.48 2.21V3h.86a14.6 14.6 0 0110.94 5.4A13.73 13.73 0 0128.93 20a14.06 14.06 0 01-6.62 9l1.51 1zM7.76 3.87a15.59 15.59 0 00-7.45 10.3 15.32 15.32 0 003 12.51 16.29 16.29 0 0011.6 6.17l.81.06v1.4l3.6-2-3.46-2.41-.07 1.42-.85-.07a14.6 14.6 0 01-10.66-5.94 13.73 13.73 0 01-2.14-11.73A14.06 14.06 0 019.22 4.9l-1.46-1z"/>
      <path d="M15.75 25a.71.71 0 01-.72-.69v-1.1l-.24-.06a3.84 3.84 0 01-2.6-2.17.66.66 0 010-.51.7.7 0 01.39-.39.75.75 0 01.28-.06.72.72 0 01.67.43 2.4 2.4 0 002.24 1.46 2.19 2.19 0 002.42-2.1c0-1-.84-1.73-2.58-2.12h-.11c-3.11-.7-3.58-2.47-3.58-3.46a3.47 3.47 0 012.88-3.37h.26V9.69a.72.72 0 011.45 0v1.1l.25.06A3.83 3.83 0 0119 12.44a.67.67 0 01-.2 1 .74.74 0 01-.56.1.72.72 0 01-.46-.32 2.42 2.42 0 00-2-1.11 2.19 2.19 0 00-2.41 2.1c0 1 .85 1.74 2.58 2.12 3.21.73 3.69 2.48 3.69 3.46a3.47 3.47 0 01-2.88 3.37h-.26v1.08a.71.71 0 01-.75.76z"/>
    </SvgIcon>
  )
}
export default RefundIcon
